// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bd_fg","conditions__content":"bd_fh","conditions__footer":"bd_fj"};